export default {
    accept_document: "Кабыл алуу",
    agreement_status_not_signed: "Кол коюлган эмес",
    agreement_status_signed: "Кол коюлган",
    all_other_countries: "Башка бардык өлкөлөр",
    effective_at: "Күчүнө кирүү күнү",
    legal_agreement: "Келишим",
    legal_document: "Юридикалык документ",
    legal_document_countries_note: "Эгер эч бир өлкө тандалбаса, документ ушул түрдөгү өз документи жок бардык өлкөлөргө колдонулат.",
    legal_document_is_active_note: "Ар бир документ түрү жана аймагы үчүн бир гана версия активдүү боло алат. Бул версияны активдештирүү мурунку активдүү версияны автоматтык түрдө өчүрөт.",
    legal_document_must_accept_note: "Иштөөнү улантуу үчүн документ менен таанышып, аны кабыл алышыңыз керек.",
    legal_document_superadmin_authority_note: "Документти кабыл алуу менен сиз уюмдун атынан аракет кылууга ыйгарым укугуңуз бар экенин тастыктайсыз.",
    legal_document_type: "Документтин түрү",
    legal_document_type_offer_contract: "Оферта келишими",
    legal_document_type_integrations_agreement: "Үчүнчү тараптын кызматтарын жана интеграцияларын колдонуу келишими",
    legal_document_type_usage_agreement: "Программаны колдонуу келишими",
    legal_document_usage_agreement_note: "Документти кабыл алуу менен сиз программаны колдонуу эрежелери менен таанышканыңызды жана аларды сактоого милдеттенгениңизди тастыктайсыз.",
    legal_documents: "Юридикалык документтер",
    loading: "Жүктөлүүдө",
    no_legal_documents_for_region: "Сиздин аймагыңыз үчүн азырынча эч бир документ жарыяланган жок",
    open_document: "Документти ачуу",
    requires_reacceptance: "Кайра кабыл алуу талап кылынат",
    requires_reacceptance_note: "Иштетилген болсо, мурунку версияны кабыл алган колдонуучулар кийинки кирүүдө бул версияны кайра кабыл алышы керек болот.",
    version: "Версия"
}
